import { render } from "./SignsEdit.vue?vue&type=template&id=fd1a51aa"
import script from "./SignsEdit.vue?vue&type=script&lang=js"
export * from "./SignsEdit.vue?vue&type=script&lang=js"

import "./SignsEdit.vue?vue&type=style&index=0&id=fd1a51aa&lang=css"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__